import { useNotification } from '@/containers'
import { type StaticImageData } from 'next/image'
import { type FC } from 'react'
import { CompareAddIcon } from '../Icon/CompareAddIcon'
import ImageOptimize from '../ImageOptimize'

interface Props {
  imgSrc: StaticImageData | string | undefined
  imgAlt: string
  id: string
  finalPrice: string
  salePrice: string
  name: string
  className?: string
  canCompare?: boolean
  handleAddToCompare?: () => void
}
export const SearchProductItemCard: FC<Props> = ({
  imgSrc,
  imgAlt,
  name,
  finalPrice,
  salePrice,
  canCompare,
  className = '',
  handleAddToCompare,
}) => {
  const { systemConfig } = useNotification()

  return (
    <div className='flex border-b py-[16px] pl-[24px] items-center'>
      <ImageOptimize
        alt={imgAlt}
        src={
          imgSrc ||
          systemConfig?.imagePlaceholder ||
          process.env.NEXT_PUBLIC_IMAGE_PLACEHOLDER ||
          ''
        }
        width={72}
        priority
        height={72}
        className='h-full max-h-[72px] w-[72px] object-cover'
      />
      <div
        className={`ml-[24px] pr-[24px] ${className}`}
      >
        <p className={`clamp-2 text-[#000] ${canCompare && 'max-w-[310px]'}`}>
          {name}
        </p>
        <p className='text-[#282828] font-normal line-through'>{salePrice}</p>
        <p className='memberPrice text-[#F00000] font-extrabold'>
          {finalPrice}
        </p>
      </div>
      {canCompare && (
        <button
          onClick={handleAddToCompare}
          className='r-[10px] relative flex w-[125px] items-center flex-[135px] justify-end'
        >
          <CompareAddIcon className='mr-[5px]'></CompareAddIcon>
          <span className='text-blue'>So sánh</span>
        </button>
      )}
    </div>
  )
}
